<template>
  <!--
      作者 WuYuseng
      时间：2019-10-26
      描述：设置-商户信息修改
  -->
    <div>

      <!--form表单-->
      <el-form size="small" ref="formData" :model="formData" label-width="150px">
        <div class="common-form">店铺信息</div>
        <el-form-item label="店铺名称" :rules="[{required: true,message: '请输入店铺名称'}]">
          <el-input v-model="formData.name" placeholder="请输入店铺名称" class="max-w460"></el-input>
        </el-form-item>
        <!-- <el-form-item label="联系人" :rules="[{required: true,message: '请输入联系人'}]">
          <el-input v-model="formData.link_name" placeholder="请输入联系人" class="max-w460"></el-input>
        </el-form-item> -->

        <el-form-item label="联系电话" :rules="[{required: true,message: '请输入电话'}]">
          <el-input v-model="formData.link_phone" placeholder="请输入联系电话（短信通知用）" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="语音电话">
          <el-input v-model="formData.call_phone" placeholder="请输入语音电话（AI语音客服用）" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="email" :rules="[{required: true,message: '请输入email'}]">
          <el-input v-model="formData.email" placeholder="请输入email" class="max-w460"></el-input>
        </el-form-item>

<!--        <el-form-item label="商家介绍" :rules="[{required: true,message: '请输入商家介绍'}]">-->
<!--          <el-input type="textarea" v-model="formData.description" placeholder="请输入商家介绍" class="max-w460"></el-input>-->
<!--        </el-form-item>-->

        <el-form-item label="logo" :rules="[{required: true,message: '选择Logo'}]">
          <el-button @click="openProductUpload('image', 'logo')">选择Logo</el-button>
          <div v-if="formData.logo_id!=''" class="img">
            <img :src="logo_file_path" width="100" height="100" />
          </div>
        </el-form-item>

        <el-form-item label="门店简介" :rules="[{required: true,message: '请输入门店简介'}]">
          <el-input v-model="formData.about_us" placeholder="请输入门店简介" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="视频">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="formData.videos">
              <transition-group>
                <div class="item" v-for="(item, index) in formData.videos" :key="item.file_path || index">
                  <video width="100%" height="100%" :src="item.file_path" :autoplay="false" controls></video>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteVideo(index)"><i class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('video', 'video')"><i class="el-icon-plus"></i></div>
          </div>
        </el-form-item>

        <el-form-item label="我们的工作图片：" :rules="[{ required: true, message: '请上传我们的工作图片' }]" prop="image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="formData.image">
              <transition-group>
                <div class="item" v-for="(item, index) in formData.image" :key="item.file_path">
                  <img v-img-url="item.file_path" />
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('image', 'image')"><i class="el-icon-plus"></i></div>
          </div>
        </el-form-item>

        <el-form-item label="详细地址" prop="address" :rules="[{required: true,message: ' '}]">
          <el-input v-model="formData.address" placeholder="请输入详细地址" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="店铺坐标">
          <el-row class="mb16">
            <el-col :span="24">
              <el-input v-model="formData.coordinate" class="max-w460"></el-input>
            </el-col>
          </el-row>
          <el-row class="mb16">
            <el-col :span="24">
              <GetPointGmap :form="formData" :initial-location="initialLocation" @getMapdata="getMapdataFunc" @chose="choseFunc"></GetPointGmap>
            </el-col>
          </el-row>

        </el-form-item>

        <div class="common-form">营业时间</div>
        <el-form-item label="周一">
          <el-time-select
            placeholder="起始时间"
            v-model="formData.mondy_start"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00'
            }">
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="formData.mondy_end"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00',
              minTime: formData.mondy_start
            }">
          </el-time-select>
        </el-form-item>

        <el-form-item label="周二">
          <el-time-select
            placeholder="起始时间"
            v-model="formData.tuesday_start"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00'
            }">
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="formData.tuesday_end"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00',
              minTime: formData.tuesday_start
            }">
          </el-time-select>
        </el-form-item>

        <el-form-item label="周三">
          <el-time-select
            placeholder="起始时间"
            v-model="formData.wednesday_start"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00'
            }">
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="formData.wednesday_end"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00',
              minTime: formData.wednesday_start
            }">
          </el-time-select>
        </el-form-item>

        <el-form-item label="周四">
          <el-time-select
            placeholder="起始时间"
            v-model="formData.thursday_start"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00'
            }">
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="formData.thursday_end"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00',
              minTime: formData.thursday_start
            }">
          </el-time-select>
        </el-form-item>

        <el-form-item label="周五">
          <el-time-select
            placeholder="起始时间"
            v-model="formData.friday_start"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00'
            }">
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="formData.friday_end"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00',
              minTime: formData.friday_start
            }">
          </el-time-select>
        </el-form-item>

        <el-form-item label="周六">
          <el-time-select
            placeholder="起始时间"
            v-model="formData.saturday_start"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00'
            }">
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="formData.saturday_end"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00',
              minTime: formData.saturday_start
            }">
          </el-time-select>
        </el-form-item>

        <el-form-item label="周日">
          <el-time-select
            placeholder="起始时间"
            v-model="formData.sunday_start"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00'
            }">
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="formData.sunday_end"
            :picker-options="{
              start: '00:00',
              step: '00:15',
              end: '24:00',
              minTime: formData.sunday_start
            }">
          </el-time-select>
        </el-form-item>

      <!--  <el-form-item label="营业执照" :rules="[{required: true,message: '选择营业执照'}]">
          <el-button @click="chooseImg('business')">选择营业执照</el-button>
          <div v-if="formData.business_id!=''" class="img">
            <img :src="business_file_path" width="100" height="100" />
          </div>
        </el-form-item> -->

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
        </div>
      </el-form>

      <!--上传图片-->
      <Upload v-if="isupload" :config="config" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    </div>
  </template>

  <script>
    import GetPointGmap from '@/components/map/GetPointGmap.vue';
    import SettingApi from '@/api/setting.js';
    import Upload from '@/components/file/Upload';
    import draggable from 'vuedraggable';
    export default{
      components:{
        GetPointGmap,
        draggable,
        Upload
      },
      data(){
        return {
          /*是否在提交*/
          loading:false,
          /*表单数据对象*/
          formData:{
            name:'',
            link_name:'',
            link_phone:'',
            call_phone:'',
            email:'',
            address:'',
            coordinate: '',
            about_us:'',
            description:'',
            logo_id:0,
            image: [],
            videos: [],
            mondy_start: '',
            mondy_end: '',
            tuesday_start: '',
            tuesday_end: '',
            wednesday_start: '',
            wednesday_end: '',
            thursday_start: '',
            thursday_end: '',
            friday_start: '',
            friday_end: '',
            saturday_start: '',
            saturday_end: '',
            sunday_start: '',
            sunday_end: '',
            //business_id:0,
          },
          /*是否打开图片选择*/
          isupload:false,
          /*当前图片类别*/
          type:null,
          logo_file_path: '',
          // business_file_path: '',
          config: {},
          file_name: 'image',
          initialLocation: null
        }
      },
      created() {
        this.getParams();
      },
      methods:{
        /*获取经纬度*/
        getMapdataFunc(e) {
          this.formData.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
        },

        /*选择的地址*/
        choseFunc(e){
          this.formData.coordinate=e.location.lat+','+e.location.lng;
          this.formData.address=e.address;

        },

        /*删除商品图片*/
        deleteImg(index) {
          this.formData.image.splice(index, 1);
        },
        // 实时限制输入范围
        handleInput(value) {
          if (value < 0) this.formData.sunday_end = 0;
          if (value > 24) this.formData.sunday_end = 24;
        },

        // 失焦时修正空值/非法值
        handleBlur() {
          if (
            this.formData.sunday_end === '' ||
            isNaN(this.formData.sunday_end)
          ) {
            this.formData.sunday_end = 0;
          }
        },

        deleteVideo(index){
          this.formData.videos.splice(index, 1);
        },

        /*获取配置数据*/
        getParams() {
          let self = this;
          SettingApi.getSupplier({}, true).then(res => {
              self.formData = res.data.model;
              self.logo_file_path = res.data.model.logo.file_path;
              // self.business_file_path = res.data.model.business.file_path;
              // 处理坐标信息，设置初始位置
              if (self.formData.coordinate && self.formData.coordinate !== '') {
                const coords = self.formData.coordinate.split(',');
                if (coords.length === 2) {
                  self.initialLocation = {
                    lat: parseFloat(coords[0]),
                    lng: parseFloat(coords[1]),
                    name: self.formData.store_name || '店铺位置',
                    address: self.formData.address || '',
                    isInitial: true // 标记这是初始位置
                  };
                }
              }
            })
            .catch(error => {

            });
        },

        /*提交*/
        onSubmit() {
          let self = this;
          let params = this.formData;
          self.$refs.formData.validate((valid) => {
            if (valid) {
              self.loading = true;
              SettingApi.setSupplier(params, true)
                .then(data => {
                  self.loading = false;
                  self.$message({
                    message: '恭喜你，保存设置成功',
                    type: 'success'
                  });
                })
                .catch(error => {
                  self.loading = false;
                });
            }
          });

        },

        /*打开上传图片*/
        openProductUpload: function(file_type, file_name) {
          this.file_name = file_name;
          if(file_type == 'image'){
            if(file_name == 'logo'){
              this.config = {
                total: 1,
                file_type: 'image'
              };
            }else{
              this.config = {
                total: 9,
                file_type: 'image'
              };
            }
          }else{
            var remain = 9 - this.formData.videos.length;
            this.config = {
              total: remain > 0 ? remain : 0,
              file_type: 'video'
            };
          }
          this.isupload = true;
        },

        returnImgsFunc(e) {
          if (e != null) {
            if(this.file_name == 'video'){
              let videos = this.formData.videos.concat(e);
              this.$set(this.formData, 'videos', videos);
            }else if(this.file_name == 'image'){
              let imgs = this.formData.image.concat(e);
              this.$set(this.formData, 'image', imgs);
            }else if(this.file_name == 'logo'){
              this.logo_file_path = e[0].file_path;
              this.formData.logo_id = e[0].file_id;
            }
          }
          this.isupload = false;
        }
      }
    }
  </script>

  <style>
  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }

  .input-group {
    display: flex;
    align-items: center;
  }

  .input-group .el-input {
    width: 120px; /* 可根据需要调整宽度 */
    margin-right: 8px;
  }

  .input-group .el-input:last-child {
    margin-right: 0;
  }

  .separator {
    margin: 0 8px;
  }
  </style>



// WEBPACK FOOTER //
// src/views/setting/supplier/index.vue